import { PageHeader } from "../PageHeader";

/**
 * StubPage — clean placeholder for a canonical /dashboard/* route whose NEW page
 * is not rebuilt yet. Replaces the legacy "bridge to an old-nav page" pattern:
 * the new app renders THIS, never an Old* page. Removed per founder directive
 * 2026-06-07 ("no more bridging to old pages — clean stub until the new one ships").
 */
export function StubPage({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <div className="p-4 lg:p-6 space-y-6 max-w-7xl mx-auto">
      <PageHeader title={title} subtitle={subtitle} />
      <div className="adp-card flex flex-col items-center justify-center gap-2 py-16 text-center">
        <p className="text-base font-medium text-foreground">{title}</p>
        <p className="max-w-xl text-sm text-muted-foreground">Diese Seite wird gerade neu gebaut.</p>
        <p className="mt-2 text-[11px] text-mono uppercase tracking-wider text-muted-foreground">In Arbeit</p>
      </div>
    </div>
  );
}
